export const COMPANY_NAME = "PL ELL REO LLC";
export const COMPANY_SHORT = "PL Ell Reo";
export const COMPANY_INITIALS = "PER";
export const COMPANY_ADDRESS_FULL = "700 Newport Center Dr, Newport Beach, California, US 92660-6307";
export const COMPANY_LOCATION = "Newport Beach, CA";
export const COMPANY_REGION = "Orange County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=700%20Newport%20Center%20Dr%2C%20Newport%20Beach%2C%20California%2C%20US%2092660-6307";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory listing" },
  { "label": "Region", "value": "Orange County" },
  { "label": "Location", "value": "Newport Beach, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "PL ELL REO LLC" },
  { "label": "Location", "value": "Newport Beach, California" },
  { "label": "Address", "value": "700 Newport Center Dr, Newport Beach, California, US 92660-6307" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Directory profile", "body": "A concise public profile built from the organization details provided." },
  { "icon": "✦", "title": "Location details", "body": "Address information is presented for straightforward local reference." },
  { "icon": "✿", "title": "Public information", "body": "This page intentionally focuses on safe, high-level directory information." },
  { "icon": "❍", "title": "Visit", "body": "Use the map link to view the listed Newport Beach address." },
];
